<template>
  <link rel="stylesheet" crossorigin="anonymous"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"/>
  <link rel="stylesheet" crossorigin="anonymous"
        href="https://unpkg.com/vue-multiselect@2.1.0/dist/vue-multiselect.min.css">
  <div v-if="isLoading || !ready || appStore.appLoading"
       class="w-100 bg-white min-vh-100 d-flex align-items-center justify-content-center flex-column">
    <img src="../public/loading.gif" class="loading-img" alt=""/>
    <div>
      <div class="loading-text">
        {{ $t('misc.loadingText') }}
      </div>
      <div class="loading-subtext">
        {{ $t('misc.loadingSubText') }}
      </div>
    </div>
  </div>
  <div v-else>
    <div class="main" v-if="ready">
        <div class="d-flex unselectable">
          <NavigationView v-if="!DISABLED_SIDEBAR_ROUTES.includes(currentRouteName) && currentRouteName"/>
          <div id="main-content" class="content col bg-2"
               :class="{ 'p-0': DISABLED_SIDEBAR_ROUTES.includes(currentRouteName) }">
            <router-view/>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import {useAuth0} from '@auth0/auth0-vue';
import { useAppStore, usePresentStore} from "@/store";
import NavigationView from "@/components/navigation/NavigationView.vue";
import {useToast} from "vue-toastification";
import { useMousePressed, useInterval } from '@vueuse/core'

const LOG_TIME = 2; // In minutes

export default {
  data() {
    return {
      ready: false,
      DISABLED_SIDEBAR_ROUTES: [
          '403',
          'login',
          'logout',
          'composer',
          'preview',
          'display',
          'otp'
      ],
      intervalLog: null,
      stats_to_deploy: [],
      clicks: 0
    }
  },
  setup() {
    const {isLoading, user, isAuthenticated, getAccessTokenSilently} = useAuth0();
    const appStore = useAppStore();
    const presentStore = usePresentStore();
    const { pressed } = useMousePressed()
    const { counter, reset } = useInterval(1000, { controls: true });

    return {appStore, presentStore, isLoading, user, isAuthenticated, getAccessTokenSilently, pressed, counter, reset};
  },
  beforeMount() {
    // this.appStore.hotels = hotels;
    if (!localStorage.getItem("first_login")) {
      localStorage.setItem("first_login", "false")
    }
  },
  methods: {
    async setupApp() {
      try {
        if(localStorage.getItem("first_login") === "false") {
            if(!await this.appStore.authenticateUser(this.user))
              return this.$router.replace({
                name: "logout",
              });

            if(!await this.appStore.getTenantsList())
              return this.$router.replace({
                  name: "logout",
              });


           // Creation of Tenant
           await this.appStore.setupTenantList()
           // Creation of User (Login Info)
           await this.appStore.setupDB(this.user)
           // Creation of Groups and tenant mapping
           const adminList = this.appStore.hotels.filter((item) => item.role === 'client-admin');
           adminList.length && await this.appStore.setupAdmins(adminList);
           // Assign Groups to hotel list
           await this.appStore.setupGroups()
           await this.appStore.fetchCityAndAirportData()

           localStorage.setItem("first_login", "true")
        } else {
          await this.appStore.getTenantsList()
          await this.appStore.setupGroups()
        }

        if (this.appStore.tenant === null) {
          useToast().success("Welcome to Signage!");
        }

        // set tenant correctly according to the retrieved hotel list
        await this.appStore.setTenant(this.appStore.hotels.find(hotel => hotel.ncm === this.appStore.tenant)?.ncm || this.appStore.hotels[0].ncm);

        await this.appStore.getSettings()
        if(this.currentRouteName !== 'display'){
          await this.appStore.getFonts()
          // DATA USAGE LOGGING
          this.logDataUsage();
          this.intervalLog = setInterval(async () => {
            await this.logDataUsage()
          }, LOG_TIME * 60 * 1000);
        }        

      } catch (error) {
        localStorage.setItem("first_login", "false")
        console.error('An error occurred:', error);
      }
    },
    async logDataUsage() {
      if(this.stats_to_deploy.length){
        this.stats_to_deploy[this.stats_to_deploy.length - 1].clicks = this.clicks;
        this.stats_to_deploy[this.stats_to_deploy.length - 1].elapsed_time = this.counter;
        await this.appStore.logDataUsage(this.stats_to_deploy);
      }
      this.stats_to_deploy = [];
      this.pushLog(this.currentRouteName);
    },
    addRouteLog(route){
      this.stats_to_deploy[this.stats_to_deploy.length - 1].clicks = this.clicks;
      this.stats_to_deploy[this.stats_to_deploy.length - 1].elapsed_time = this.counter;
      this.pushLog(route);
    },
    pushLog(route){
      this.reset();
      this.clicks = 0;

      this.stats_to_deploy.push({
        ncm_id: this.appStore.getCurrentTenant,
        email: this.user.email,
        role: this.appStore.getCurrentRole,
        clicks: 0,
        elapsed_time: 0,
        module: route,
        "@timestamp": this.$dayjs.utc().format('YYYY-MM-DDTHH:mm:ss')
      })
    }
  },
  beforeUnmount() {
    if(this.intervalLog) clearInterval(this.intervalLog);
  },
  mounted() {
  },
  watch: {
    async isLoading(loading) {
      if (!loading) {

        if (!await this.appStore.isAlive()) {
          useToast().error("Backend API is not connected.");
          return;
        }

        if(!this.isAuthenticated || !this.user){
          localStorage.setItem("first_login", "false")
        }

        if (this.isAuthenticated && this.user) {
          try {
            await this.getAccessTokenSilently();
          } catch (error) {
            this.$router.replace({
              name: "logout",
          });
          }

          await this.setupApp()
        }

        this.$nextTick(() => {
          this.ready = true
        })
      }
    },
    pressed(val) {
      if(!this.isAuthenticated || !this.ready) return; 
      if(val){
        this.clicks++;
      }
    },
    currentRouteName(route, oldRoute){
      if(!oldRoute) return;
      this.addRouteLog(route)
    }
  },
  components: {
    NavigationView,
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
};
</script>
<style lang="scss" scoped>
html, 
body {
  min-height: 100%;
  height: 100%;
}

.content {
  padding-left: 0.70rem;
  padding-right: 0.75rem;
  transition-property: margin-left;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 0.2s;
}

.loading-img{
  width: 100px;
  height: 100px;
}

.loading-text {
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: 0.5px;
  text-align: center;
  color: #8d8d8d;
}

.loading-subtext {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: 0.5px;
  text-align: center;
  color: #8d8d8d;
}
</style>

